import React from "react"
import PhoneInput from "react-phone-number-input/max"
import flags from "react-phone-number-input/flags"
import {
  PhoneNumberWrapper,
  Label,
  ErrorWrapper,
  ErrorMessage,
  FormIcon,
} from "./styles"
import "react-phone-number-input/style.css"
import Icon from "../Icon"
import { isProfileMode } from "utils/productUtils"
import Translate from "components/Translate/container"

const PhoneNumber = props => {
  const formatNumber = value => {
    if (value.substring(0, 1) === "0") {
      return `+44${value.substring(1)}`
    } else {
      return value
    }
  }

  const {
    id,
    value,
    label,
    forceErrorDisplay,
    errorMessage,
    error,
    defaultCountry,
  } = props

  const processedNumber = formatNumber(value)

  let countries
  if (isProfileMode()) {
    countries = ["GB"]
  }

  return props.disabled ? (
    props.value
  ) : (
    <PhoneNumberWrapper
      className={error && forceErrorDisplay ? "hasError" : null}
    >
      <Label>
        <Translate>{label}</Translate>
      </Label>
      <PhoneInput
        label={label}
        placeholder={props.label}
        id={id}
        international
        flags={isProfileMode() ? "GB" : flags}
        countries={countries}
        countryCallingCodeEditable={false}
        limitMaxLength={true}
        defaultCountry={defaultCountry}
        value={processedNumber}
        onChange={ev1 => {
          props.onChange(props.id, ev1)
        }}
      />
      {error && forceErrorDisplay && (
        <ErrorWrapper>
          <ErrorMessage>
            <Translate>{errorMessage}</Translate>
            <FormIcon variant={"danger"}>
              <Icon variant={"warning"} />
            </FormIcon>
          </ErrorMessage>
        </ErrorWrapper>
      )}
    </PhoneNumberWrapper>
  )
}

export default PhoneNumber
